import { Link, NavLink, useNavigate } from "react-router-dom";
import { StatusPill } from "./StatusPill";
import { getWallet, shortFingerprint } from "../lib/wallet";
import { useEffect, useState } from "react";

const navItems = [
  { to: "/", label: "Overview", end: true, testid: "nav-overview" },
  { to: "/explore", label: "Shape a use case", testid: "nav-explore" },
  { to: "/about", label: "About KATLAS", testid: "nav-about" },
  { to: "/wallet", label: "Wallet", testid: "nav-wallet" },
];

export const SiteHeader = () => {
  const navigate = useNavigate();
  const [wallet, setWallet] = useState(null);
  useEffect(() => {
    setWallet(getWallet());
    const onStorage = () => setWallet(getWallet());
    window.addEventListener("storage", onStorage);
    window.addEventListener("cierge-wallet-changed", onStorage);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("cierge-wallet-changed", onStorage);
    };
  }, []);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 border-b border-border/80 bg-white/95 backdrop-blur"
    >
      <div className="mx-auto flex max-w-[1280px] items-center justify-between px-6 py-4 lg:px-10">
        <Link
          to="/"
          data-testid="brand-link"
          className="flex items-baseline gap-3 whitespace-nowrap"
        >
          <span className="font-serif text-lg font-light tracking-tight text-foreground">
            Cierge Labs
          </span>
          <span className="hidden h-3 w-px self-center bg-border lg:inline-block" />
          <span className="hidden font-mono text-[10px] uppercase tracking-[0.22em] text-muted-foreground lg:inline-block">
            Governed use-case studio
          </span>
        </Link>

        <nav className="hidden items-center gap-7 md:flex" aria-label="Primary">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={item.testid}
              className={({ isActive }) =>
                `relative font-mono text-[11px] uppercase tracking-[0.18em] transition-colors ${
                  isActive
                    ? "text-foreground"
                    : "text-muted-foreground hover:text-foreground"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {item.label}
                  {isActive && (
                    <span className="absolute -bottom-2 left-0 h-px w-full bg-foreground" />
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <StatusPill tone="light" compact testid="header-status-pill" />
          {wallet ? (
            <button
              type="button"
              data-testid="header-wallet-fingerprint"
              onClick={() => navigate("/wallet")}
              className="hidden border border-border bg-white px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.16em] text-foreground transition-colors hover:border-foreground sm:inline-block"
            >
              <span className="text-muted-foreground">key </span>
              {shortFingerprint(wallet.fingerprint)}
            </button>
          ) : null}
        </div>
      </div>
    </header>
  );
};
